// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3X5XD","col":"styles_col__28_g-","actions":"styles_actions__3ZuQN","conflict":"styles_conflict__3ZXJM"};